import(/* webpackMode: "eager", webpackExports: ["MainLayoutClient"] */ "/opt/atlassian/pipelines/agent/build/packages/app/src/app/[...slug]/layout.client.tsx");
